export const DISPLAY_ICON_TEST_ID = 'drawingToolDropdownDisplayIcon';

export const LABEL_ICON_TEST_ID = 'drawingToolDropdownLabelIcon';

export const TEST_ID = 'drawingToolDropdown';

export { DRAWING_TOOL } from 'components/Map/constants';
